// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';

import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import Badge from '@cloudscape-design/components/badge';

const navHeaderSecurity = { text: 'Menú', href: '#/' };
export const navItemsSecurity: SideNavigationProps['items'] = [

      
      {
      type: 'section',
      text: 'Usuarios',
      items: [
        { type: 'link', text: 'Listado', href: '#/distributions3' },
        { type: 'link', text: 'Agregar', href: '#/cache' },
        {
          type: 'link', text: 'Pendientes', href: '#/howto',
          info: <Badge color="blue">23</Badge>
        },
      ],
    },
    {
      type: 'section',
      text: 'Seguridad',
      items: [
        { type: 'link', text: 'Políticas', href: '#/howto3' },
        { type: 'link', text: 'Exclusiones', href: '#/origin3' },
        { type: 'link', text: 'Asignación', href: '#/origin3' },
        { type: 'link', text: 'Geolocalización', href: '#/origin3' },
        { type: 'link', text: 'Bloqueos', href: '#/origin3' },
      ],
    },
    {
      type: "section",
      text: "Notificaciones",
      items: []
    },
    {
      type: "section",
      text: "Invitaciones",
      items: []
    },
    {
      type: "section",
      text: "Reportes",
      items: []
    },
    {
      type: "section",
      text: "Facturación",
      items: [
        { type: 'link', text: 'Emitidas', href: '#/howto3' },
        { type: 'link', text: 'Notificar Pago', href: '#/howto3' },
        { type: 'link', text: 'Pendientes', href: '#/howto3' },]
    },
    {
      type: "section",
      text: "Configuración",
      items: [
        { type: 'link', text: 'Propiedades', href: '#/howto3' },
        { type: 'link', text: 'Accesos', href: '#/howto3' },
        { type: 'link', text: 'Unidades', href: '#/howto3' },]
    },
];

const defaultOnFollowHandler: SideNavigationProps['onFollow'] = event => {
  // keep the locked href for our demo pages
  event.preventDefault();
};

interface NavigationProps {
  activeHref?: string;
  header?: SideNavigationProps['header'];
  items?: SideNavigationProps['items'];
  onFollowHandler?: SideNavigationProps['onFollow'];
}

export function NavigationSecurity({
  activeHref,
  header = navHeaderSecurity,
  items = navItemsSecurity,
  onFollowHandler = defaultOnFollowHandler,
}: NavigationProps) {
  return <SideNavigation items={items} header={header} activeHref={activeHref} onFollow={onFollowHandler} />;
}
